import type { AnalyticsLot, AnalyticsOwner } from '~/analytics/blocks/types'
import type { AmplitudePayloadResult, AnalyticsStore } from '~/analytics/composables-types'
import { getGlobalPreviewCatalog } from '~/analytics/composables-types'
import {
  appendLotProductOwnerFields,
  getProductPageSourceFields,
} from '~/composables/useLotProductAnalytics'

interface ClickOwnerChatParams {
  store: AnalyticsStore
  lot?: AnalyticsLot | null
  user?: AnalyticsOwner | null
}

export function getClickOwnerChatAmplitudePayload ({
  store,
  lot,
  user,
}: ClickOwnerChatParams): AmplitudePayloadResult {
  if (!lot) {
    return {}
  }

  const payload: AmplitudePayloadResult = {
    ...getProductPageSourceFields(lot),
  }

  return appendLotProductOwnerFields(payload, {
    rootGetters: store.getters,
    lot,
    owner: user || lot.user,
    productList: getGlobalPreviewCatalog(),
  })
}
